import { useNotify, useRefresh } from 'react-admin'

import { captureExceptionIfProduction } from 'helpers/utils'
import { offboardTeam, reapplyTeam, reonboardTeam } from '../../../api/core'
import { TeamTransitions } from '../Transitions/TeamFSMTransitions'
import { FSMTransitionButton, XTransitionButtonProps } from './FSMTransitionButton'

const isOffboardTeam = (action: any) => action === TeamTransitions.offboard.transitionAction
const isReapplyingTeam = (action: any) => action === TeamTransitions.reapply.transitionAction
const isTeamReonboardTeam = (action: any) => action === TeamTransitions.reonboard.transitionAction

export const TeamTransitionButton = ({
  record,
  transitionProps,
  classes,
  loading,
  setLoading,
}: XTransitionButtonProps) => {
  const notify = useNotify()
  const refresh = useRefresh()

  /* State  */
  const { transitionAction } = transitionProps

  const isTeamOffboardTransition = isOffboardTeam(transitionAction)
  const isTeamReapplyTransition = isReapplyingTeam(transitionAction)
  const isTeamReonboardTransition = isTeamReonboardTeam(transitionAction)

  const handleSubmit = () => {
    let transitionApi = null
    if (isTeamOffboardTransition) {
      transitionApi = offboardTeam
    }
    if (isTeamReapplyTransition) {
      transitionApi = reapplyTeam
    }
    if (isTeamReonboardTransition) {
      transitionApi = reonboardTeam
    }
    if (transitionApi) {
      setLoading(true)
      transitionApi(record.id)
        .then(() => {
          refresh()
          setLoading(false)
          notify('Transition Successful!', { type: 'success' })
        })
        .catch((error) => {
          setLoading(false)
          notify(error.response.data, { type: 'error' })
          captureExceptionIfProduction(error)
        })
    }
  }

  return (
    <FSMTransitionButton
      className={classes?.root}
      record={record}
      transitionProps={transitionProps}
      handleSubmit={handleSubmit}
      loading={loading}
    ></FSMTransitionButton>
  )
}
